import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { LambdaService } from './lambda.service';
declare const $: any;

@Injectable({
  providedIn: 'root',
})
export class ThemingService {
  shopId = 0;
  shopGuid = '';
  isLoginRequired = 0;
  shopTheming: ShopTheming[] = [];
  childParentIds: number[] = [];
  activeShopId: number = 1; // tienda activa seleccionada
  activeShopId$ = new BehaviorSubject<number>(this.activeShopId);
  childShops: { shopId: number; shopName: string, shopLogo?: string, shopGuid: string }[] = [];
  navBarCatergories: NavbarCategory[] = [];

  termsAndConditions: string =
    'https://mobydyg-files.s3.amazonaws.com/1/dev/config-files/terms-file.html';
  privacyPolicies: string =
    'https://mobydyg-files.s3.amazonaws.com/1/dev/config-files/policy-file.html';
  onlinePolicies: string =
    'https://mobydyg-files.s3.amazonaws.com/1/dev/config-files/online-policy.html';

  shouldShowShopSelector = false;

  constructor(public apiService: ApiService, private router: Router, public lambdaService: LambdaService) { }

  // async getNavbarCategories() {
  //   return this.apiService.getThemingService(this.shopId).then((data: any) => {
  //     this.navBarCatergories = data.categories.map((category: any) => {
  //       let finalCategory: any = {};
  //       finalCategory['categoryId'] = category.categoryId;
  //       finalCategory['name'] = category.categoryName;
  //       finalCategory['icon'] = category.categoryNonActiveIcon;
  //       finalCategory['iconActive'] = category.categoryActiveIcon;

  //       return finalCategory;
  //     });
  //   });
  // }

  getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  async getThemingService() {
    this.getShopId();

    if (!this.shopGuid || this.shopGuid === '0') {
      this.shopTheming = [];
      throw new Error('Missing shopGuid context.');
    }

    const fromParentFlag = this.getCookie('fromParent') === 'true';
    if (fromParentFlag && !document.referrer.includes(window.location.hostname)) {
      document.cookie = "fromParent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      localStorage.removeItem('parentShopInfo');
    }

    return this.lambdaService
      .getThemingService(this.shopGuid)
      .then((data: any) => {
        if (!data?.themingService || !Array.isArray(data.themingService) || data.themingService.length === 0) {
          throw new Error('Empty theming response for current shop context.');
        }

        // console.log(data);

        this.shopId = data.themingService[0].shopId;
        this.shopGuid = data.themingService[0].shopGuid;

        this.childParentIds = Array.isArray(data.childParentId) ? data.childParentId : [];

        // Determines the current shop type
        const isParent = !data.themingService[0].parentLevelId; // Is parent if no parentLevelId
        const isChild = !!data.themingService[0].parentLevelId; // Is child if has parentLevelId
        const hasChildren = this.childParentIds.length > 0;  // Has child shops

        const rawParentInfo = localStorage.getItem('parentShopInfo');
        let parentShopFromStorage: any = rawParentInfo ? JSON.parse(rawParentInfo) : null;
        const fromParentFlag = this.getCookie('fromParent') === 'true';

        const hasValidParentContext = isChild && fromParentFlag && parentShopFromStorage;

        if (isChild) {
          if (!fromParentFlag) {
            localStorage.removeItem('parentShopInfo');
            parentShopFromStorage = null;
          } else if (!parentShopFromStorage) {
            document.cookie = "fromParent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          }
        }

        // If it's a parent with children, saves its info for future navigation
        if (isParent && hasChildren) {
          localStorage.setItem('parentShopInfo', JSON.stringify({
            shopId: data.themingService[0].shopId,
            shopGuid: data.themingService[0].shopGuid,
            shopName: data.themingService[0].shopName,
            shopLogo: data.themingService[0].shopLogoSmall
          }));
        }

        // Maps available child shops
        this.childShops = Array.isArray(data.childParentId) ? data.childParentId.map((shop: any) => ({
          shopId: shop.shopId,
          shopGuid: shop.shopGuid,
          shopName: shop.shopName ?? `Tienda #${shop.shopId}`,
          shopLogo: shop.shopLogoSmall ?? '/assets/default-shop-icon.png'
        })) : [];

        // If it's a child and there's parent info, adds it to the beginning of the list
        if (isChild && parentShopFromStorage) {
          const alreadyExists = this.childShops.some(s => s.shopId === parentShopFromStorage.shopId);
          if (!alreadyExists) {
            this.childShops.unshift({
              shopId: parentShopFromStorage.shopId,
              shopGuid: parentShopFromStorage.shopGuid,
              shopName: parentShopFromStorage.shopName,
              shopLogo: parentShopFromStorage.shopLogo ?? '/assets/default-shop-icon.png'
            });
          }
        }

        const isChildWithValidContext = isChild && fromParentFlag && parentShopFromStorage;
        const isParentWithChildren = isParent && hasChildren;

        this.shouldShowShopSelector = isParentWithChildren || isChildWithValidContext;


        this.shopTheming = data.themingService.map((theme: any) => {

          this.termsAndConditions = `https://mobydyg-files.s3.amazonaws.com/${theme.shopId}/${environment.stage == 'prod' ? 'prod' : 'dev'}/config-files/terms-file.html`;
          this.privacyPolicies = `https://mobydyg-files.s3.amazonaws.com/${theme.shopId}/${environment.stage == 'prod' ? 'prod' : 'dev'}/config-files/policy-file.html`;
          this.onlinePolicies = `https://mobydyg-files.s3.amazonaws.com/${theme.shopId}/${environment.stage == 'prod' ? 'prod' : 'dev'}/config-files/online-policy.html`;
          let finalTheme: any = {};
          finalTheme['shopId'] = theme.shopId;
          finalTheme['shopDomain'] = theme.shopDomain;
          finalTheme['shopName'] = theme.shopName;
          finalTheme['currentContract'] = theme.shopCurrentContract;
          finalTheme['shopSubscription'] = data.shopSubscription[0];
          finalTheme['country'] = data.country[0].countryName;
          finalTheme['countryLanguage'] = data.country[0].countryLanguage;
          finalTheme['countryCode'] = data.country[0].countryCode;
          finalTheme['countryTimeZone'] = data.country[0].countryTimeZone;
          finalTheme['currencyCode'] = data.currency[0].currencyCode;
          finalTheme['messaging'] = theme.shopMessaging;
          finalTheme['messageImage'] = data.themingService[0].messageImage;
          finalTheme['mail'] = theme.shopMail;
          finalTheme['phone'] = data.shopPoints[0].shopPointPhone;
          finalTheme['version'] = theme.versionBackoffice;
          finalTheme['countryTimeZone'] = data.country[0].countryTimeZone;
          finalTheme['isLoginRequired'] = theme.isLoginRequired;
          finalTheme['socialMedia'] = data.socialMedia.map(
            (socialMedia: any) => {
              let finalSocialMedia: any = {};
              finalSocialMedia['socialMediaName'] = socialMedia.socialMediaName;
              finalSocialMedia['socialMediaURL'] = socialMedia.socialMediaURL;
              finalSocialMedia['socialMediaIcon'] = socialMedia.socialMediaIcon;
              return finalSocialMedia;
            }
          );
          finalTheme['shopsLocation'] = data.shopPoints.map((location: any) => {
            let finalLocations: any = {};
            finalLocations['shopPointId'] = location.shopPointId;
            finalLocations['shopPointName'] = location.shopPointName;
            finalLocations['shopPointLocation'] = location.shopPointLocation;
            finalLocations['shopPointPhone'] = location.shopPointPhone;
            return finalLocations;
          });

          finalTheme['missingImage'] = '/assets/static/missing-image.png';
          finalTheme['shopPoints'] = data.shopPoints;
          finalTheme['locations'] = data.shopPoints[0].shopPointLocation;
          finalTheme['amplifyConfig'] = theme.shopAmplifyConfig;
          finalTheme['amplifyConfigBackoffice'] = theme.shopAmplifyConfigBackoffice;
          finalTheme['shopLogoWhite'] = theme.shopLogoWhite;
          finalTheme['shopLogoLarge'] = theme.shopLogoLarge;
          finalTheme['shopLogoSmall'] = theme.shopLogoSmall;
          finalTheme['companyBanner'] = theme.companyBanner;
          finalTheme['mainColor'] = theme.shopLogoMainColor;
          finalTheme['mainColorLight'] = theme.shopLogoMainColorLight;
          finalTheme['mainColorDark'] = theme.shopLogoMainColorDark;
          finalTheme['grayTitleActive'] = theme.shopLogoMainColorTitleActive;
          finalTheme['grayPlaceholder'] = theme.shopLogoMainColorTitlePlaceholder;
          finalTheme['fontFamily1'] = theme.shopFontFamily1;
          finalTheme['fontFamily2'] = theme.shopFontFamily2;
          finalTheme['showSearchBar'] = theme.showSearchBar;
          finalTheme['showAuthButtons'] = theme.showAuthButtons;
          finalTheme['showRegisterButtons'] = theme.showRegisterButtons;
          finalTheme['showCart'] = theme.showCart;
          finalTheme['languageSelectorPosition'] = theme.languageSelectorPosition;
          finalTheme['headerBackground'] = theme.headerBackground ?? null;
          finalTheme['footerBackground'] = theme.footerBackground ?? null;
          finalTheme['shopIntegration'] = theme.shopIntegration != '' && theme.shopIntegration != undefined;
          finalTheme['shopFavicon'] = theme.shopFavicon;

          return finalTheme;
        });
        const allShopIds = [this.shopId, ...this.childShops.map((shop) => shop.shopId)];
        if (allShopIds.includes(this.shopId)) {
          this.activeShopId = this.shopId;
        } else if (this.childShops.length > 0) {
          this.activeShopId = this.childShops[0].shopId;
        }
      })
      .catch((error) => {
        this.shopTheming = [];
        console.error(error);
        throw error;
      });
  }

  // Public getter to check selector visibility
  private evaluateShopSelectorVisibility(
    isParent: boolean,
    isChild: boolean,
    hasChildren: boolean,
    parentShopFromStorage: any,
    fromParentFlag: boolean
  ): boolean {
    const validChildContext = isChild && fromParentFlag && parentShopFromStorage;
    const validParent = isParent && hasChildren;
    return validParent || validChildContext;
  }

  // Detects if it's a direct child entry (without parent context)
  private detectDirectChildEntry(isChild: boolean, hasChildren: boolean, parentShopFromStorage: string | null): boolean {
    return isChild && !parentShopFromStorage;
  }

  getShouldShowShopSelector(): boolean { // Public getter to check selector visibility
    return this.shouldShowShopSelector;
  }

  // Method to chance the active shop
  // This method will be used to change the active shop in the navbar
  // and notify the components
  setActiveShop(shopId: number) {
    this.activeShopId = shopId;
    this.activeShopId$.next(shopId);
  }

  setShopId(shopId: number, shopGuid: string) {
    this.shopId = shopId;
    this.shopGuid = shopGuid;
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 1);
    document.cookie = `shopGuid=${shopGuid}; expires=${expirationDate.toUTCString()};`
  }

  getShopId() {
    let cookieShopGuid = this.getShopIdCookie("shopGuid");
    this.shopGuid = cookieShopGuid || "";
    return cookieShopGuid;
  }

  getShopIdCookie(cookieName: string) {
    // Add an equals sign to the cookie name for easier matching
    const name = cookieName + "=";
    // Decode the entire cookie string to handle URL-encoded characters
    const decodedCookie = decodeURIComponent(document.cookie);
    // Split the string into an array of individual cookies
    const cookieArray = decodedCookie.split(';');

    // Iterate through the array to find the desired cookie
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      // Trim any leading whitespace from the cookie string
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      // Check if this cookie starts with the target name
      if (cookie.indexOf(name) === 0) {
        // If found, return the value by extracting the substring after the name
        return cookie.substring(name.length, cookie.length);
      }
    }
    // Return null if the cookie is not found
    return null;
  }

  initialize(): Promise<boolean> {
    // const queryString = window.location.search;
    // const urlParams = new URLSearchParams(queryString);
    // this.shopId = parseInt(<any>urlParams.get('shopId'));
    // history.pushState(
    //   {},
    //   'null',
    //   window.location.pathname + `?shopId=${this.shopId}`
    // );
    // this.router.events.subscribe((val) => {
    //   history.pushState(
    //     {},
    //     'null',
    //     window.location.pathname + `?shopId=${this.shopId}`
    //   );
    // });

    return new Promise<boolean>(async (resolve) => {
      try {
        await this.getThemingService();
        resolve(true);
      } catch (error) {
        console.warn('Theming initialization failed:', error);
        resolve(false);
      }
    });
  }
}

export interface NavbarCategory {
  name: string;
  categoryId: number;
  icon: string;
  iconActive: string;
}

export interface ShopTheming {
  shopId: number;
  shopName: string;
  currentContract: string;
  shopSubscription: any;
  country: string;
  countryLanguage: string;
  countryTimeZone: string;
  countryCode: string;
  currencyCode: string;
  phone: string;
  messaging: string;
  messageImage: string;
  mail: string;
  shopLogoWhite: string;
  shopLogoLarge: string;
  shopLogoSmall: string;
  companyBanner?: string;
  mainColor: string;
  mainColorLight: string;
  mainColorDark: string;
  grayTitleActive: string;
  grayPlaceholder: string;
  fontFamily1: string;
  fontFamily2: string;
  showSearchBar?: boolean;
  showAuthButtons?: boolean;
  showRegisterButtons?: boolean;
  showCart?: boolean;
  languageSelectorPosition?: 'navbar' | 'footer';
  headerBackground?: any;
  footerBackground?: any;
  locations: string[];
  shopsLocation: string[];
  socialMedia: any[];
  enableSinpe: boolean;
  amplifyConfig: string;
  amplifyConfigBackoffice: string;
  shopIntegration: boolean;
  missingImage: string;
  version: string;
  shopDomain: string
  shopFavicon: string
  childParentId: number;
  isLoginRequired: number;
  shopPoints: any[];
}
